module.exports = __webpack_public_path__ + "img/service-1-guanzhu.f259adc1.png";